import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { UrlConstantes } from "../utilerias/constantes/urlconstantes";
import {
  Prompt,
  PromptRes,
  PromptSeccion,
} from "../shared/model/prompts/prompt.model";

@Injectable({
  providedIn: "root",
})
export class PromptsService {
  constructor(private http: HttpClient) {}

  /**
   * Todo el catálogo de un tiro: secciones con sus prompts dentro, los
   * sistemas de IA para el selector, y si el usuario puede administrar.
   *
   * En una sola llamada para que no haya un instante con los prompts ya
   * pintados y los botones de edición apareciendo después.
   */
  consultar(): Observable<PromptRes> {
    return this.http.post<PromptRes>(UrlConstantes.PROMPTS_CONSULTAR, {});
  }

  guardar(prompt: Prompt): Observable<PromptRes> {
    return this.http.post<PromptRes>(UrlConstantes.PROMPTS_GUARDAR, { prompt });
  }

  eliminar(idPrompt: number): Observable<PromptRes> {
    return this.http.post<PromptRes>(UrlConstantes.PROMPTS_ELIMINAR, {
      idPrompt,
    });
  }

  guardarSeccion(seccion: PromptSeccion): Observable<PromptRes> {
    return this.http.post<PromptRes>(UrlConstantes.PROMPTS_SECCION_GUARDAR, {
      seccion,
    });
  }

  eliminarSeccion(idPromptSeccion: number): Observable<PromptRes> {
    return this.http.post<PromptRes>(UrlConstantes.PROMPTS_SECCION_ELIMINAR, {
      idPromptSeccion,
    });
  }

  /** Las áreas con su estado en el catálogo. Sólo quien administra. */
  areas(): Observable<PromptRes> {
    return this.http.post<PromptRes>(UrlConstantes.PROMPTS_AREAS_CONSULTAR, {});
  }

  /**
   * Deja marcadas exactamente estas áreas. Va la lista completa, no la
   * que cambió: así el servidor decide qué se prende y qué se apaga
   * contra lo que tiene guardado.
   */
  guardarAreas(idAreas: number[]): Observable<PromptRes> {
    return this.http.post<PromptRes>(UrlConstantes.PROMPTS_AREAS_GUARDAR, {
      idAreas,
    });
  }

  /** Lo dado de baja. Se pide al abrir la papelera, no en cada carga. */
  retirados(): Observable<PromptRes> {
    return this.http.post<PromptRes>(UrlConstantes.PROMPTS_RETIRADOS, {});
  }

  /** Devuelve un prompt retirado a su área. Responde con los que quedan. */
  restaurar(idPrompt: number): Observable<PromptRes> {
    return this.http.post<PromptRes>(UrlConstantes.PROMPTS_RESTAURAR, {
      idPrompt,
    });
  }
}
